import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import clsx from 'clsx';
import { createChainedFunction } from '@atc/create-chained-function';
import { RadioGroup as ReaxlRadioGroup, FormElementHelp, FormElementLabel, ErrorMessages } from 'reaxl';
import CommonFormComponent from '../hocs/CommonFormComponent';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function RadioGroup(_ref) {
  let {
    buttons,
    columnClasses,
    columns,
    disabled,
    formElementProps = {},
    isFormDisabled,
    name,
    onChange,
    options,
    rootClasses,
    setValue,
    toolbar,
    value,
    type = 'stacked',
    ...rest
  } = _ref;
  const handleChange = event => {
    setValue(event.currentTarget.value);
  };
  const {
    help,
    errors,
    showErrors,
    layout,
    labelProps
  } = formElementProps;
  const chainedFunction = createChainedFunction(handleChange, onChange);
  const elementOnly = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ReaxlRadioGroup, {
      columnClasses: columnClasses,
      columns: columns,
      containerClasses: clsx({
        'btn-group': buttons && toolbar
      }),
      disabled: isFormDisabled || disabled,
      labelClassName: clsx({
        'btn btn-default radio-btn': buttons
      }),
      name: name,
      onChange: chainedFunction,
      options: options,
      type: type,
      value: value
    }), /*#__PURE__*/_jsx(FormElementHelp, {
      help: help
    }), /*#__PURE__*/_jsx(ErrorMessages, {
      errors: errors,
      showErrors: showErrors
    })]
  });
  if (layout === 'elementOnly') {
    return elementOnly;
  }

  // Clean up props to allow key to be spread as a prop from HOC
  Object.keys(rest).forEach(key => {
    if (key !== 'key') {
      delete rest[key];
    }
  });
  return /*#__PURE__*/_jsxs("div", {
    ...rest,
    className: rootClasses,
    children: [/*#__PURE__*/_jsx(FormElementLabel, {
      ...labelProps
    }), layout === 'horizontal' && /*#__PURE__*/_jsx("div", {
      className: clsx({
        'col-xs-5': layout === 'horizontal'
      }),
      children: elementOnly
    }), layout !== 'horizontal' && elementOnly]
  });
}
export default /* #__PURE__ */withFormsy(/* #__PURE__ */CommonFormComponent(/*#__PURE__*/memo(RadioGroup)));